import type { CostProfileData } from 'lumen/utils/net-revenue/types';

/**
 * The cost drilldown has content to show when there is at least one named
 * cost-profile row, or unattributed bookings that render a "Remaining
 * reservations" row. Mirrors the row gate in the cost-drilldown-section
 * `rows` getter (`remainingReservations.roomNights > 0`) so the empty-state
 * checks stay in sync with what the table actually renders.
 */
export function hasCostProfileContent(
  data: CostProfileData | undefined,
): boolean {
  const hasRows = (data?.rows.length ?? 0) > 0;
  const hasRemaining = (data?.remainingReservations?.roomNights ?? 0) > 0;
  return hasRows || hasRemaining;
}
